import { render, staticRenderFns } from "./copertoplufaturaislem.vue?vue&type=template&id=64a3b581&"
import script from "./copertoplufaturaislem.vue?vue&type=script&lang=js&"
export * from "./copertoplufaturaislem.vue?vue&type=script&lang=js&"
import style0 from "./copertoplufaturaislem.vue?vue&type=style&index=0&id=64a3b581&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports